import { useEffect, useState } from "react";
import { IndianRupee, TrendingUp, Clock } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { api } from "@/lib/api";
import { rupees } from "@/lib/utils-lc";

const STATUS = { held: "bg-amber-100 text-amber-800", pending_cash: "bg-amber-100 text-amber-800", released: "bg-emerald-100 text-emerald-800" };

export default function Earnings() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/earnings/mine").then(r => setData(r.data)).catch(() => setData({ total_earned_inr: 0, pending_inr: 0, payments: [], commission_pct: 10 })); }, []);
  if (!data) return <div className="text-sm text-slate-500">Loading…</div>;

  return (
    <div className="space-y-5">
      <div className="grid sm:grid-cols-2 gap-4">
        <Card className="p-5 rounded-2xl border-slate-200 bg-white">
          <div className="text-xs uppercase tracking-[0.2em] text-slate-500 flex items-center gap-1.5"><TrendingUp className="w-3.5 h-3.5" /> Earned (released)</div>
          <div className="font-display text-3xl font-extrabold mt-2 flex items-center"><IndianRupee className="w-6 h-6" />{Number(data.total_earned_inr).toLocaleString("en-IN")}</div>
        </Card>
        <Card className="p-5 rounded-2xl border-slate-200 bg-white">
          <div className="text-xs uppercase tracking-[0.2em] text-slate-500 flex items-center gap-1.5"><Clock className="w-3.5 h-3.5" /> Pending release</div>
          <div className="font-display text-3xl font-extrabold mt-2 flex items-center"><IndianRupee className="w-6 h-6" />{Number(data.pending_inr).toLocaleString("en-IN")}</div>
        </Card>
      </div>

      <div className="text-xs uppercase tracking-[0.2em] text-slate-500">History</div>
      {data.payments.length === 0 ? (
        <Card className="rounded-2xl border-dashed border-slate-300 p-8 text-center text-slate-500 bg-white">No earnings yet — get confirmed for a shift to start tracking here.</Card>
      ) : (
        <div className="space-y-3">
          {data.payments.map(p => (
            <Card key={p.payment_id} className="p-4 rounded-2xl border-slate-200 bg-white" data-testid={`payment-row-${p.payment_id}`}>
              <div className="flex items-start justify-between gap-3">
                <div>
                  <div className="font-display font-semibold">{p.shift?.facility_name || "Shift"}</div>
                  <div className="text-xs text-slate-500">{p.shift?.specialty} · {p.shift?.date}</div>
                </div>
                <Badge className={(STATUS[p.status] || "bg-slate-100 text-slate-800") + " hover:" + (STATUS[p.status] || "bg-slate-100 text-slate-800")}>{p.status}</Badge>
              </div>
              <div className="mt-3 grid grid-cols-3 gap-2 text-xs text-slate-500">
                <div>Gross<div className="text-slate-800 font-semibold text-sm mt-0.5">{rupees(p.amount_inr)}</div></div>
                <div>Fee ({data.commission_pct}%)<div className="text-slate-800 font-semibold text-sm mt-0.5">−{rupees(p.commission_inr)}</div></div>
                <div>Net<div className="text-emerald-800 font-semibold text-sm mt-0.5">{rupees(p.net_inr)}</div></div>
              </div>
              <div className="mt-2 text-[11px] text-slate-500 uppercase tracking-[0.15em]">{p.method === "mock_escrow" ? "Escrow" : p.method}</div>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
